let _Math = require("../lib/Math");

class PlotXAxis extends React.Component {
  componentDidMount() {
    this.plot();
  }

  componentDidUpdate() {
    this.plot();
  }

  plot() {
    let { scaleX, domainX, formatX, height } = this.props;

    let xNode = d3.select(this.refs.axis);

    let xAxis = d3.axisBottom()
      .scale(scaleX)
      .tickSizeInner(height + 5)
      .tickValues(domainX.ticks) // may be null
      .tickFormat(formatX); // may be null

    xNode.call(xAxis);
  }

  render() {
    let { width, height, margin, label } = this.props;

    return (
      <g className="mc-plot-x-axis">
        <text x={width / 2} y={height + margin.bottom - 5}>
          {label}
        </text>
        <g ref="axis"/>
      </g>
    );
  }
}

class PlotXAxisNav extends React.Component {
  componentDidMount() {
    this.plot();
  }

  componentDidUpdate() {
    this.plot();
  }

  plot() {
    let { scaleX, formatX, getX, data, onClick } = this.props;

    let hitNode = d3.select(this.refs.hit);
    let crossNode = d3.select(this.refs.cross);
    let textNode = d3.select(this.refs.text);

    let targetX = function () {
      let point = d3.mouse(hitNode.node());
      let x = scaleX.invert(point[0]);
      let datum = _Math.nearest(data, x, null, getX);

      return getX(datum) || Math.round(x);
    };

    if (data.length) {
      hitNode.on("mousemove", () => {
        let x = targetX();

        crossNode
          .attr("transform", "translate(" + scaleX(x) + ")")
          .style("visibility", "visible");

        textNode.text(formatX(x));
      }).on("click", () => {
        let x = targetX();

        onClick(x);
      }).on("mouseout", () => {
        crossNode
          .style("visibility", "hidden");
      });
    }
  }

  render() {
    let { width, height } = this.props;

    return (
      <g className="mc-plot-x-axis-nav">
        <rect width={width} height={height} fillOpacity={0} ref="hit"/>
        <g ref="cross">
          <line y1={0} y2={height + 3} stroke="black"/>
          <g transform={`translate(-20,${height + 3})`}>
            <rect width="40" height="20" rx="10" ry="10"/>
            <text width="40" x="20" y="14" ref="text"/>
          </g>
        </g>
      </g>
    );
  }
}

PlotXAxis.Nav = PlotXAxisNav;

module.exports = PlotXAxis;